const SESSION_KEYS = {
  default: 'ZY_PORTAL_SESSION',
  postAbility: 'ZY_POST_ABILITY_PORTAL_SESSION'
}
const AUTH_EVENT = 'zy-auth-changed'

function emitAuthChange() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_EVENT))
  }
}

function resolveSessionKey(scope = 'default') {
  return SESSION_KEYS[scope] || SESSION_KEYS.default
}

export function getScopedSession(scope = 'default') {
  if (typeof window === 'undefined') {
    return null
  }

  const rawValue = window.localStorage.getItem(resolveSessionKey(scope))
  if (!rawValue) {
    return null
  }

  try {
    return JSON.parse(rawValue)
  } catch (error) {
    window.localStorage.removeItem(resolveSessionKey(scope))
    return null
  }
}

export function getSession() {
  return getScopedSession()
}

export function setScopedSession(session, scope = 'default') {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(resolveSessionKey(scope), JSON.stringify(session))
  emitAuthChange()
}

export function setSession(session) {
  setScopedSession(session)
}

export function clearScopedSession(scope = 'default') {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.removeItem(resolveSessionKey(scope))
  emitAuthChange()
}

export function clearSession() {
  clearScopedSession()
}

export function getScopedToken(scope = 'default') {
  const session = getScopedSession(scope)
  return session && session.token ? session.token : ''
}

export function getToken() {
  return getScopedToken()
}

export function isScopedAuthenticated(scope = 'default') {
  const session = getScopedSession(scope)
  return Boolean(session && session.token)
}

export function isAuthenticated() {
  return isScopedAuthenticated()
}

export function getAuthEventName() {
  return AUTH_EVENT
}

export function maskIdCard(idCard) {
  if (!idCard || idCard.length < 8) {
    return idCard || ''
  }

  return `${idCard.slice(0, 4)}********${idCard.slice(-4)}`
}
